import React from 'react';

export default class SendMoneyIcon extends React.Component {

    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                x="0"
                y="0"
                version="1.1"
                viewBox="0 0 41.99 41.998"
                xmlSpace="preserve"
            >
                <path d="M20 9.998v1c-1.65 0-3 1.35-3 3s1.35 3 3 3v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v1c0 .55.45 1 1 1s1-.45 1-1v-1c1.65 0 3-1.35 3-3s-1.35-3-3-3v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2v-1c0-.55-.45-1-1-1s-1 .45-1 1zm0 5c-.55 0-1-.45-1-1s.45-1 1-1zm2 2c.55 0 1 .45 1 1s-.45 1-1 1z"></path>
                <path d="M30 15.998c0-4.96-4.04-9-9-9s-9 4.04-9 9 4.04 9 9 9 9-4.04 9-9zm-16 0c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7-7-3.14-7-7z"></path>
                <path d="M41.84 16.488a.836.836 0 00-.18-.23c-.01-.01-.02-.03-.03-.04l-3.63-2.9v-8.32c0-1.1-.9-2-2-2H25.1L21.62.218c-.37-.29-.88-.29-1.25 0l-3.47 2.78H6c-1.1 0-2 .9-2 2v8.32l-3.62 2.9c-.01.01-.02.03-.03.04-.07.07-.13.15-.18.23-.02.03-.05.06-.07.1a.92.92 0 00-.1.41v24c0 .04.02.07.02.1.01.07.02.13.04.2s.05.13.08.19c.02.03.02.06.04.09l.06.06c.04.05.09.1.15.14.05.04.1.08.15.1.05.03.11.05.17.07.07.02.13.04.2.04.04 0 .06.01.09.01h40c.15 0 .29-.04.42-.1.04-.02.06-.05.1-.07.09-.06.17-.13.24-.21.02-.02.04-.03.05-.05.02-.03.02-.06.04-.09.03-.06.06-.12.08-.19.02-.07.03-.13.04-.2 0-.03.02-.06.02-.1v-23.99c0-.15-.04-.29-.09-.41-.01-.04-.04-.07-.06-.1zm-3.84-.61l1.4 1.12-1.4 1.12zm-17-13.6l.9.72h-1.8zM6 4.998h30v14.72l-11.04 8.83-3.39-2.37c-.34-.24-.8-.24-1.15 0l-3.39 2.37L6 19.718zm-2 10.88v2.24l-1.4-1.12zm-2 3.2l13.33 10.67L2 39.078zm2.17 20.92L21 28.218l16.83 11.78zm35.83-.92l-13.33-9.33L40 19.078z"></path>
            </svg>
        )
    }

}
